import { EditFilled, StopOutlined } from '@ant-design/icons';
import { Tag } from 'antd';

import { Button } from '../../components/index';
import { createDateStringPtBrSeconds } from '../../utils/utils';
import { LoginTokensResponse } from '../../types';
import { useRevokeTokenMutation } from '../../services/authApi';

export function columns(onBlock: (record: any) => void) {
  return [
    {
      title: <div className="show-amount">Usuário</div>,
      dataIndex: 'username',
      key: 'title',
      render: (text: string) => text,
      showSorterTooltip: false,
    },
    {
      title: 'Estado',
      key: 'is_blacklisted',
      render: (loginToken: LoginTokensResponse) => {
        if (loginToken.expires_at) {
          const expires_date = new Date(loginToken.expires_at);
          const now = new Date();
          if (loginToken.is_blacklisted) {
            return <Tag color="red">bloqueado</Tag>;
          }
          if (expires_date < now) {
            return <Tag color="default">expirado</Tag>;
          }
          return <Tag color="green">ativo</Tag>;
        }
        return <> - </>;
      },
    },
    {
      title: 'Identificador',
      dataIndex: 'jti',
      key: 'jti',
      render: (jti: 'string') => <span>{jti}</span>,
    },
    {
      title: 'Criado em',
      dataIndex: 'created_at',
      key: 'created_at',
      render: (created_at: 'string') => (
        <span>{createDateStringPtBrSeconds(created_at)}</span>
      ),
    },
    {
      title: 'Expira em',
      dataIndex: 'expires_at',
      key: 'expires_at',
      render: (expires_at: 'string') => (
        <span>{createDateStringPtBrSeconds(expires_at)}</span>
      ),
    },
    {
      width: '10%',
      title: 'Bloquear',
      render: (_text: any, record: any) => {
        return (
          <Button
            type="text"
            icon={<StopOutlined />}
            onClick={() => onBlock(record)}
            style={{ float: 'right' }}
            disabled={record.is_blacklisted}
          />
        );
      },
    },
  ];
}
